import { render, staticRenderFns } from "./Mate.vue?vue&type=template&id=c66c4bf2"
import script from "./Mate.vue?vue&type=script&lang=js"
export * from "./Mate.vue?vue&type=script&lang=js"
import style0 from "./Mate.vue?vue&type=style&index=0&id=c66c4bf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports